import script from "./FeedbackLetterStudentsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackLetterStudentsDialog.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackLetterStudentsDialog.vue?vue&type=style&index=0&id=380a321d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-380a321d"]])

export default __exports__